import React from 'react';
import {
    AddIcon,
    IconCanceledByVisitorCard,
    IconFingerprint,
    RenewIcon,
} from '../../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../../components/CustomTooltip';
import { FINGERPRINT_MODEL, FingerprintStatus } from '../Model/Models';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import { CustomTextField } from '../../../../../components/CustomTextField';
/**
 *
 * @Author: Susana García Rodriguez
 * @JobTitle : Frontend Developer - IBL
 * @Email : sgarcia@ibl.mx
 *
 */
const FingerprintCapture = ({
    t,
    fingerprintStatus,
    handleCaptureFinger,
    handleCancel,
    fingerprintName,
    setFingerprintName,
    handleUploadFinger,
    setEmptyFields,
    emptyFields
}) => {


    const config = FINGERPRINT_MODEL[fingerprintStatus];

    return (
        <div className={"border-radius-8px border-full-shades-300 h-100"}>
             <div className='d-flex flex-column h-100'>
                <div>
                    <div className='d-flex align-items-center p-3'>
                        < IconFingerprint />

                        <div className='ml-2'>
                            <CustomTooltip
                                text={t('fingerprint_capture')}
                                classes='font-color-general-950 ibl-font-w-600 fs-14px text-ellipsis-1-row'
                                showIfTruncated
                                placement='top'
                            />
                        </div>
                    </div>
                    <div className='border-bottom-shades-300' />
                </div>
                <div className={"pb-3"}>
                    <div className='d-flex flex-column align-items-center justify-content-center py-4 text-center'>
                        <div className='d-flex flex-column align-items-center w-150px'>
                            <div className={`mb-3 ${config.classes.icon || ''}`}>{config.icon}</div>

                            <div className={`${config.classes.title} text-center w-100`}>{t(config.title)}</div>

                            {config.subtitle && (
                                <div className={`${config.classes.subtitle} text-center w-100 text-break`}>
                                    {t(config.subtitle)}
                                </div>
                            )}
                        </div>
                    </div>
                    {(fingerprintStatus === FingerprintStatus.INITIAL || fingerprintStatus === FingerprintStatus.CONNECTED) && (
                        <div className='d-flex justify-content-center align-items-center'>
                            <ButtonAction
                                id='btn_fc_add_fingerprint'
                                name='add'
                                className='btn-secondary-600'
                                Icon={AddIcon}
                                onClick={handleCaptureFinger}
                            />
                        </div>
                    )}
                    {fingerprintStatus === FingerprintStatus.NO_DEVICE && (
                        <div className='d-flex justify-content-center align-items-center'>
                            <ButtonAction
                                id='btn_fc_cancel'
                                name='cancel'
                                className='btn-outlined-error-600'
                                Icon={IconCanceledByVisitorCard}
                                onClick={handleCancel}
                            />
                        </div>
                    )}
                    {fingerprintStatus === FingerprintStatus.CAPTURED && (
                        <div className='d-flex flex-column gap-3'>
                            <div className='w-100'>
                                <CustomTextField
                                    id='txt_fc_finger'
                                    length={128}
                                    name='finger'
                                    value={fingerprintName}
                                    trans='finger'
                                    type='text'
                                    onChange={(e) => setFingerprintName(e.target.value)}
                                    emptyFields={emptyFields}
                                    required={true}
                                />
                            </div>

                            <div className='d-flex justify-content-between gap-2'>
                                <div className='w-50'>
                                    <ButtonAction
                                        id='btn_fc_try_again'
                                        name='try_again'
                                        className='btn-secondary-600 w-100'
                                        Icon={RenewIcon}
                                        splitName={false}
                                        onClick={handleCancel}
                                    />
                                </div>

                                <div className='w-50'>
                                    <ButtonAction
                                        id='btn_fc_confirm'
                                        name='confirm'
                                        className='btn-icon-add w-100'
                                        onClick={() => {
                                            if (!fingerprintName || fingerprintName.trim() === '') {
                                                setEmptyFields(true);
                                                return;
                                            }

                                            setEmptyFields(false);
                                            handleUploadFinger();
                                            handleCancel();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
             </div>
        </div>
    );
};

export default FingerprintCapture;
